export default __webpack_public_path__ + "static/media/Ansys.2986add0.png";